import React from 'react'
import SkyLight from 'react-skylight'
import * as request from 'superagent'
import RadioG from 'react-radio-group'
import { ToastContainer, ToastMessage } from 'react-toastr'
import { getToken } from '../Commons/Authentication'
import MiddleLine from '../../img/icons/general-icons/separator_icon.png'
import DiabeticoImage from '../../img/special-conditions/diabetico.png'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

export default class DiabetesData extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({
      duracionDm: null, presSistolica: 0,
      hba1c: '', selectedAlb: 'No', IAMValue: 'No', ICCValue: 'No',
      ACVValue: 'No', AngPrev: 'No', ojosValue: '0', corazonValue: '0',_id: '',
      rinonValue: '0', neuroValue: '0', cerebroValue: '0',
      vascularValue: '0', metabValue: '0', changeClass: false, textTime: '',
      textH: '', timeClass: 'severity-input', hba1cClass: 'severity-input',
      fevi: '', fase: '', funcional:'', pieDiabeValue: ''
    })
  }


  componentWillMount () {
    var sistolica = (this.props.data.presionParadoAlta + this.props.data.presionSentadoAlta) / 2
    console.log(this.props.data)
    this.setState({ presSistolica: sistolica })
  }

  pieDiabeticoV (changeEvent) {
      if (changeEvent.target.value === 'Si') {
          this.setState({ pieDiabeValue: changeEvent.target.value })
      } else {
          this.setState({ pieDiabeValue: changeEvent.target.value })
      }
  }

  feviChange () {
      this.setState({ fevi: this.refs.fevi.value })
  }

  faseChange () {
      this.setState({ fase: this.refs.fase.value })
  }

  funcionalChange () {
      this.setState({ funcional: this.refs.funcional.value })
  }

  IAMDM (changeEvent) {
    if (changeEvent.target.value === 'Si') {
      this.setState({ IAMValue: changeEvent.target.value })
    } else {
      this.setState({ IAMValue: changeEvent.target.value })
    }
  }

  ICCDM (changeEvent) {
    if (changeEvent.target.value === 'Si') {
      this.setState({ ICCValue: changeEvent.target.value })
    } else {
      this.setState({ ICCValue: changeEvent.target.value })
    }
  }

  ACVVAL (changeEvent) {
    if (changeEvent.target.value === 'Si') {
      this.setState({ ACVValue: changeEvent.target.value })
    } else {
      this.setState({ ACVValue: changeEvent.target.value })
    }
  }

  ANGPRE (changeEvent) {
    if (changeEvent.target.value === 'Si') {
      this.setState({ AngPrev: changeEvent.target.value })
    } else {
      this.setState({ AngPrev: changeEvent.target.value })
    }
  }

  albuminuria (changeEvent) {
    if (changeEvent.target.value === 'Si') {
      this.setState({ selectedAlb: changeEvent.target.value })
    } else {
      this.setState({ selectedAlb: changeEvent.target.value })
    }
  }

  pieDiabeticoV (changeEvent) {
    if (changeEvent.target.value === 'Si') {
      this.setState({ pieDiabeValue: changeEvent.target.value })
    } else {
      this.setState({ pieDiabeValue: changeEvent.target.value })
    }
  }

  feviChange () {
    this.setState({ fevi: this.refs.fevi.value })
  }

  faseChange () {
    this.setState({ fase: this.refs.fase.value })
  }

  funcionalChange () {
    this.setState({ funcional: this.refs.funcional.value })
  }

  ojosHandleChange (e) {
    this.setState({ ojosValue: e.target.value })
  }

  rinonHandleChange (e) {
    this.setState({ rinonValue: e.target.value })
  }

  corazonHandleChange (e) {
    this.setState({ corazonValue: e.target.value })
  }

  nueroHandleChange (e) {
    this.setState({ neuroValue: e.target.value })
  }

  cerebroHandleChange (e) {
    this.setState({ cerebroValue: e.target.value })
  }

  vascularHandleChange (e) {
    this.setState({ vascularValue: e.target.value })
  }
  metabHandleChange (e) {
    this.setState({ metabValue: e.target.value })
  }

  hba1cHandleChange () {
    this.setState({ hba1c: this.refs.HbA1c.value })
    var inputdataType = new RegExp('^-?\\d*(\\.\\d+)?$')

    if (Number(this.refs.HbA1c.value) > 15 || Number(this.refs.HbA1c.value) < 5) {
      this.setState({ textH: 'Ingrese un valor entre 5 y 15', hba1cClass: 'severity-input severity-input-error' })
    } else if (inputdataType.test(this.refs.HbA1c.value) === false) {
      this.setState({ textH: 'Ingrese un valor numérico', hba1cClass: 'severity-input severity-input-error' })
    } else {
      this.setState({ textH: '', hba1cClass: 'severity-input' })
    }
  }

  extremeAlert () {
    this.saveDiabetes()
    this.refs.container.error('Por favor remite el paciente a observación ya que el valor ingresado indica que la salud de paciente no es buena', '¡El estado de salud del paciente no es bueno!', {
      closeButton: true
    })
  }

  duracionDmChange () {
    this.setState({ duracionDm: this.refs.time.value })
    var currentYear = new Date().getFullYear()
    var inputdataType = new RegExp('^\\d{1,2}$')
    if (Number(this.refs.time.value) > this.props.data.patientAge || Number(this.refs.time.value) < 0) {
      this.setState({ textTime: 'La duración de la diabetes no puede ser mayor a la edad del paciente', timeClass: 'severity-input severity-input-error' })
    } else if (inputdataType.test(this.refs.time.value) === false) {
      this.setState({ textTime: 'Ingrese un número entre 0 y ' + this.props.data.patientAge, timeClass: 'severity-input severity-input-error' })
    } else {
      this.setState({ textTime: '', timeClass: 'severity-input' })
    }
  }

  riesgosBooleanToStr (data) {
    if (data === true) {
      return 'Si'
    } else {
      return 'No'
    }
  }


  saveDataFunction (e) {
    e.preventDefault()
    if (this.refs.time.value > this.props.data.patientAge) {
      this.setState({ textTime: 'La duración de la diabetes no puede ser mayor a la edad del paciente', timeClass: 'severity-input severity-input-error' })
    } else {
      if (Number(this.refs.HbA1c.value) > 15 || Number(this.refs.HbA1c.value) < 5) {
        this.setState({ textH: 'Ingrese un valor entre 5 y 15', hba1cClass: 'severity-input severity-input-error' })
        this.refs.container.warning(<span className='center-content'>El valor ingresado esta por fuera del rango ¿está seguro de que es el valor correcto? <br /><br /><span className='email-validation-container'><button type='button' className='btn btn-confirm clear' onClick={this.extremeAlert.bind(this)}>Si</button><button type='button' className='btn btn-confirm clear'>No</button></span></span>, <em>Valor fuera del rango</em>, {
          closeButton: true,
          'showDuration': '300',
          'hideDuration': '1000',
          'timeOut': 0,
          'extendedTimeOut': 0,
          'showEasing': 'swing',
          'hideEasing': 'linear',
          'showMethod': 'fadeIn',
          'hideMethod': 'fadeOut'
        })
      } else {
        this.saveDiabetes()
      }
    }
  }

  saveDiabetes () {
    var inputdataType = new RegExp('^\\d{1,2}$')
    if ((this.refs.HbA1c.value === '') || (this.refs.time.value === '')) {
      this.duracionDmChange()
      this.hba1cHandleChange()
    } else if (Number(this.refs.time.value) > this.props.data.patientAge || Number(this.refs.time.value) < 0) {
      this.setState({ textTime: 'La duración de la diabetes no puede ser mayor a la edad del paciente', timeClass: 'severity-input severity-input-error' })
    } else if (inputdataType.test(this.refs.HbA1c.value) === false) {
      this.setState({ textH: 'Ingrese un valor entre 5 y 15', hba1cClass: 'severity-input severity-input-error' })
    } if (Number(this.refs.time.value) > this.props.data.patientAge || Number(this.refs.time.value) < 0) {
      this.setState({ textTime: 'Ingrese un número entre 0 y ' + this.props.data.patientAge, timeClass: 'severity-input severity-input-error' })
    } else if (inputdataType.test(this.refs.time.value) === false) {
      this.setState({ textTime: 'Ingrese un número entre 0 y ' + this.props.data.patientAge, timeClass: 'severity-input severity-input-error' })
    } else {
      let identificacion = this.props.patient
      let iam = (this.state.IAMValue === 'Si')
      let icc = (this.state.ICCValue === 'Si')
      let acv = (this.state.ACVValue === 'Si')
      let ang = (this.state.AngPrev === 'Si')
      let alb = (this.state.selectedAlb === 'Si')

         console.log( this.props.data.control)
      request
      .post('api/v1/diabetes/register')
      .set('Authorization', 'Bearer ' + getToken())
      .send({
        diabetes: {
          numeroDocumento: identificacion,
          duracionDm: parseInt(this.state.duracionDm),
          presSistolica: this.state.presSistolica,
          hba1c: this.state.hba1c,
          albuminuria: alb,
          iamPrevDm: iam,
          iccPrev: icc,
          acvPrev: acv,
            control: this.state.control,
          anginaPre: ang,
            fevi: this.state.fevi,
            pieDiabeValue: this.state.pieDiabeValue,
            claseFuncional: this.state.funcional,
            clasificacionFase: this.state.fase,
          ojos: parseInt(this.state.ojosValue),
          rinon: parseInt(this.state.rinonValue),
          neuropatia: parseInt(this.state.neuroValue),
          cerebroVascular: parseInt(this.state.cerebroValue),
          corazon: parseInt(this.state.corazonValue),
          vascularPeriferico: parseInt(this.state.vascularValue),
          metabolico: parseInt(this.state.metabValue)
        }
      })
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          this.refs.container.error('Algo inesperado paso y no se pudo guardar la información', '', {
            closeButton: true
          })
        } else {
          this.refs.container.success('Los datos se guardaron correctamente', 'Datos de diabetes guardados', {
            closeButton: true
          })
          console.log('lo que guardo', res.body)
          setTimeout(() => { this.refs.diabetesDialog.hide() }, 2000)
        }
      })
    }
  }

  updateDiabetesInformation () {
      let endpoint = `api/v1/diabetes/`
      request
          .put(endpoint)
          .set('Authorization', 'Bearer ' + getToken())
          .send(
              {
                  diabetes:{
                      _id: this.state._id,
                      duracionDm: parseInt(this.state.duracionDm),
                      presSistolica: this.state.presSistolica,
                      hba1c: this.state.hba1c,
                      albuminuria: this.state.selectedAlb,
                      iamPrevDm: this.state.IAMValue,
                      iccPrev: this.state.ICCValue,
                      acvPrev: this.state.ACVValue,
                      anginaPre: this.state.AngPrev,
                      fevi: this.state.fevi,
                      pieDiabeValue: this.state.pieDiabeValue,
                      claseFuncional: this.state.funcional,
                      clasificacionFase: this.state.fase,
                      ojos: parseInt(this.state.ojosValue),
                      rinon: parseInt(this.state.rinonValue),
                      neuropatia: parseInt(this.state.neuroValue),
                      cerebroVascular: parseInt(this.state.cerebroValue),
                      corazon: parseInt(this.state.corazonValue),
                      vascularPeriferico: parseInt(this.state.vascularValue),
                      metabolico: parseInt(this.state.metabValue)

                  }
              }
          )
          .set('Accept', 'application/json')
          .end((err, res) => {
              if (err || !res.ok) {
                  this.refs.container.error('Algo inesperado paso y no se pudo guardar la información', '', {
                      closeButton: true
                  })
              } else {
                  this.refs.container.success('Los datos se guardaron correctamente', 'Datos diabeticos', {
                      closeButton: true
                  })
              }
          })
  }

  saveDiabetesInformation (e) {
    e.preventDefault()
      if (!_.isEmpty(this.state._id)) {
          let str = this.state._id
          let length = (str.length)
          if(length < 24) {
              this.saveDiabetes()
              console.log('Hola me entre por el save')
          }
          else {
              this.updateDiabetesInformation()
              console.log('Mentiras fue por el update')
          }
      } else {
          this.saveDiabetes()
      }
  }

  launchDiabetesForm (e) {
    e.preventDefault()
    var inputs = this.props.inputsRefs

    if (inputs.paparado.value === '') {
      this.props.changeStyle(true)
      this.refs.container.warning('Complete los campos P.A. Parado antes de ingresar los datos en el formulario de diabetes', '', {
        closeButton: true
      })
    } else if (inputs.psentado.value === '') {
      this.props.changeStyle(true)
      this.refs.container.warning('Complete los campos P.A. Sentado antes de ingresar los datos en el formulario de diabetes', '', {
        closeButton: true
      })
    } else if (inputs.colldl.value === '') {
      this.props.changeStyle(true)
      this.refs.container.warning('Complete el campo Colesterol LDL antes de ingresar los datos en el formulario de diabetes', '', {
        closeButton: true
      })
    } else if (inputs.colhdl.value === '') {
      this.props.changeStyle(true)
      this.refs.container.warning('Complete el campo Colesterol HDL antes de ingresar los datos en el formulario de diabetes', '', {
        closeButton: true
      })
    } else if (inputs.coltotal.value === '') {
      this.props.changeStyle(true)
      this.refs.container.warning('Complete el campo Colesterol Total antes de ingresar los datos en el formulario de diabetes', '', {
        closeButton: true
      })
    } else if (inputs.creatinina.value === '') {
      this.props.changeStyle(true)
      this.refs.container.warning('Complete el campo Creatinina antes de ingresar los datos en el formulario de diabetes', '', {
        closeButton: true
      })
    } else {
      this.refs.diabetesDialog.show()
    }
  }

  render () {
    console.log(this.props)
    var sistolica = this.props.sistolica
    var settings = {
      backgroundColor: '#02506E',
      marginTop: '-308px',
      color: '#ffffff',
      width: '58%',
      height: 'auto',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      fontSize: '14px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
        zIndex: '1001'
    }

    var year = new Date().getFullYear()

      console.log(this.props.data.diabetesControl)

    return (
        <div className='diabetes-container'>
          <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right  ' />
          <div className='diabetes-section' onClick={this.launchDiabetesForm.bind(this)}>
            <div className='diabetes-button'>Completar datos diabetes</div>
          </div>
          <SkyLight dialogStyles={settings} ref='diabetesDialog' hideOnOverlayClicked afterOpen={this._executeModalOpen}>
            <div className='diabetes-data-container'>
                {((this.props.data.patientAge <= 25) || (this.props.data.patientAge >= 85))
                    ? <div className='warning-age'>La edad del paciente es {this.props.data.patientAge} años, la cúal está fuera del rango y los cálculos no serán exactos.</div> : null}
              <div className='diabetes-field-container'>
                <div className='diabetes-severity-content'>
                  <div className='severity-data-labels-left'>
                    <label className='diabetes-data-label'>Evaluación pie diabético</label>
                    <label className='diabetes-data-label'>FEVI</label>
                    <label className='diabetes-data-label'>Clase funcional</label>
                    <label className='diabetes-data-label'>Clasificación segun fase</label>
                    <label className='diabetes-data-label'>IAM previo a DM</label>
                    <label className='diabetes-data-label'>ICC previa</label>
                  </div>
                </div>
                <div className='severity-data-labels-center'>
                  <div className='yesno-alb-container ynleft'>
                    <input id='pdyes' ref='pdyesinput' name='yespdno' type='radio' value='Si' className='yesno-alb-switch-input' checked={this.state.pieDiabeValue === 'Si'} onChange={this.pieDiabeticoV.bind(this)} />
                    <label htmlFor='pdyes' className='yesno-alb-switch-label'>Si</label>
                    <input id='pdno' ref='pdnotinput' name='yespdno' type='radio' value='No' className='yesno-alb-switch-input' checked={this.state.pieDiabeValue === 'No'} onChange={this.pieDiabeticoV.bind(this)} />
                    <label htmlFor='pdno' className='yesno-alb-switch-label'>No</label>
                  </div>
                  <input type='text' ref='fevi' id='fevi'  className='severity-input' value={this.state.fevi} onChange={this.feviChange.bind(this)}/>
                  <input type='text' ref='fase' id='fase'  className='severity-input' value={this.state.fase} onChange={this.faseChange.bind(this)}/>
                  <input type='text' ref='funcional' id='funcional'  className='severity-input' value={this.state.funcional} onChange={this.funcionalChange.bind(this)}/>
                  <div className='yesno-alb-container ynleft'>
                    <input id='iamyes' ref='iamyesinput' name='yesiamno' type='radio' value='Si' className='yesno-alb-switch-input' checked={this.state.IAMValue === 'Si'} onChange={this.IAMDM.bind(this)} />
                    <label htmlFor='iamyes' className='yesno-alb-switch-label'>Si</label>
                    <input id='iamno' ref='iamnotinput' name='yesiamno' type='radio' value='No' className='yesno-alb-switch-input' checked={this.state.IAMValue === 'No'} onChange={this.IAMDM.bind(this)} />
                    <label htmlFor='iamno' className='yesno-alb-switch-label'>No</label>
                  </div>
                  <div className='yesno-alb-container ynleft'>
                    <input id='iccyes' ref='iccyesinput' name='yesiccno' type='radio' value='Si' className='yesno-alb-switch-input' checked={this.state.ICCValue === 'Si'} onChange={this.ICCDM.bind(this)} />
                    <label htmlFor='iccyes' className='yesno-alb-switch-label'>Si</label>
                    <input id='iccno' ref='iccnotinput' name='yesiccno' type='radio' value='No' className='yesno-alb-switch-input' checked={this.state.ICCValue === 'No'} onChange={this.ICCDM.bind(this)} />
                    <label htmlFor='iccno' className='yesno-alb-switch-label'>No</label>
                  </div>
                </div>
                <div className='diabetes-severity-content'>
                  <div className='severity-data-labels-right'>
                    <label className='diabetes-data-label right-lb'></label>
                    <label className='diabetes-data-label right-lb'></label>
                    <label className='diabetes-data-label right-lb'></label>
                    <label className='diabetes-data-label right-lb'></label>
                    <label className='diabetes-data-label right-lb'></label>
                    <label className='diabetes-data-label right-lb'></label>
                  </div>
                </div>
                <div className='diabetes-severity-content left-lb'>
                  <div className='severity-data-labels-left'>
                    <label className='diabetes-data-label'>ACV previa</label>
                    <label className='diabetes-data-label'>Angina previa</label>
                    <label className='diabetes-data-label'>Albuminuria</label>
                    <label className='diabetes-data-label'>HbA1c</label>
                    <label className='diabetes-data-label'>Presión sistólica</label>
                    <label className='diabetes-data-label'>Tiempo con diabetes</label>
                    <label className='diabetes-data-label'>Año de inicio diabetes</label>
                  </div>
                </div>
                <div className='severity-data-labels-center'>
                  <div className='yesno-alb-container ynleft'>
                    <input id='acvyes' ref='acvyesinput' name='yesacvno' type='radio' value='Si' className='yesno-alb-switch-input' checked={this.state.ACVValue === 'Si'} onChange={this.ACVVAL.bind(this)} />
                    <label htmlFor='acvyes' className='yesno-alb-switch-label'>Si</label>
                    <input id='acvno' ref='acvnotinput' name='yesacvno' type='radio' value='No' className='yesno-alb-switch-input' checked={this.state.ACVValue === 'No'} onChange={this.ACVVAL.bind(this)} />
                    <label htmlFor='acvno' className='yesno-alb-switch-label'>No</label>
                  </div>
                  <div className='yesno-alb-container ynleft'>
                    <input id='angyes' ref='angyesinput' name='yesangno' type='radio' value='Si' className='yesno-alb-switch-input' checked={this.state.AngPrev === 'Si'} onChange={this.ANGPRE.bind(this)} />
                    <label htmlFor='angyes' className='yesno-alb-switch-label'>Si</label>
                    <input id='angno' ref='angnotinput' name='yesangno' type='radio' value='No' className='yesno-alb-switch-input' checked={this.state.AngPrev === 'No'} onChange={this.ANGPRE.bind(this)} />
                    <label htmlFor='angno' className='yesno-alb-switch-label'>No</label>
                  </div>
                  <div className='yesno-alb-container ynleft'>
                    <input id='albyes' ref='albyesinput' name='yesalbno' type='radio' value='Si' className='yesno-alb-switch-input' checked={this.state.selectedAlb === 'Si'} onChange={this.albuminuria.bind(this)} />
                    <label htmlFor='albyes' className='yesno-alb-switch-label'>Si</label>
                    <input id='albno' ref='albnotinput' name='yesalbno' type='radio' value='No' className='yesno-alb-switch-input' checked={this.state.selectedAlb === 'No'} onChange={this.albuminuria.bind(this)} />
                    <label htmlFor='albno' className='yesno-alb-switch-label'>No</label>
                  </div>
                  <input type='text' ref='HbA1c' id='HbA1c' className={this.state.hba1cClass} placeholder='0.00' value={this.state.hba1c} onChange={this.hba1cHandleChange.bind(this)}/>
                  <label className='severity-input severity-input-noeditable'>{sistolica}</label>
                  <input type='text' ref='time' id='time' className={this.state.timeClass} placeholder='# Años' value={this.state.duracionDm} onChange={this.duracionDmChange.bind(this)}/>
                  <label className='severity-input severity-input-noeditable'>{year - this.state.duracionDm}</label>
                </div>
                <div className='diabetes-severity-content'>
                  <div className='severity-data-labels-right'>
                    <label className='diabetes-data-label right-lb'></label>
                    <label className='diabetes-data-label right-lb'></label>
                    <label className='diabetes-data-label right-lb'></label>
                    <label className='diabetes-data-label right-lb'></label>
                    <label className='diabetes-data-label right-lb'>mmHg</label>
                    <label className='diabetes-data-label right-lb'>años</label>
                    <label className='diabetes-data-label right-lb'></label>
                  </div>
                </div>
              </div>
              <span className='validation-medical'>{this.state.textH}</span>
              <span className='validation-medical'>{this.state.textTime}</span>
              <img className='diabetes-separator' src={MiddleLine}/>
              <div className='diabetes-severity-data'>
                <div className='diabetes-info-containers'>
                  <div className='severity-title'>Puntaje de Severidad y Complicaciones (segun CIE-10)</div>
                  <div className='diabetes-severity-content'>
                    <div className='severity-data-labels-left'>
                      <label className='diabetes-data-label'>Ojos</label>
                      <label className='diabetes-data-label'>Riñon</label>
                      <label className='diabetes-data-label'>Neuropatía</label>
                      <label className='diabetes-data-label'>Cerebrovascular</label>
                      <label className='diabetes-data-label'>Corazón</label>
                      <label className='diabetes-data-label'>Vascular periférico</label>
                      <label className='diabetes-data-label'>Metabólico</label>
                    </div>
                    <div className='severity-data-labels-center'>
                      <select ref='ojos' id='ojos' className='severity-select' value={this.state.ojosValue} onChange={this.ojosHandleChange.bind(this)}>
                        <option value='0'>Ninguna</option>
                        <option value='1'>Enfermedad oftalmológica diabética</option>
                        <option value='2'>Retinopatía proliferativa desprendimiento ceguera</option>
                      </select>
                      <select ref='rinon' id='rinon' className='severity-select' value={this.state.rinonValue} onChange={this.rinonHandleChange.bind(this)}>
                        <option value='0'>Ninguna</option>
                        <option value='1'>Nefropatía diabética (nefritis, nefrosis, microalbuminuria)</option>
                        <option value='2'>Enf. Renal crónica, insuficiencia renal (cr &gt; 2mg%)</option>
                      </select>
                      <select ref='neurop' id='neurop' className='severity-select' value={this.state.neuroValue} onChange={this.nueroHandleChange.bind(this)}>
                        <option value='0'>Ninguna</option>
                        <option value='1'>Neuropatía diabética (cualquier problema o complicación)</option>
                      </select>
                      <select ref='cerebro' id='cerebro' className='severity-select' value={this.state.cerebroValue} onChange={this.cerebroHandleChange.bind(this)}>
                        <option value='0'>Ninguna</option>
                        <option value='1'>Isquemia cerebral transitoria</option>
                        <option value='2'>Accidente cerebrovascular</option>
                      </select>
                      <select ref='corazon' id='corazon' className='severity-select' value={this.state.corazonValue} onChange={this.corazonHandleChange.bind(this)}>
                        <option value='0'>Ninguna</option>
                        <option value='1'>Angina y otras formas de cardiopatía isquémica</option>
                        <option value='2'>IM, FA, ICC, aneurisma/disección</option>
                      </select>
                      <select ref='vper' id='vper' className='severity-select' value={this.state.vascularValue} onChange={this.vascularHandleChange.bind(this)}>
                        <option value='0'>Ninguna</option>
                        <option value='1'>Enfermedad vascular periférica, claudicación</option>
                        <option value='2'>Trombosis, embolia, gangrena, ulcera activa (MsIs)</option>
                      </select>
                      <select ref='metab' id='metab' className='severity-select' value={this.state.metabValue} onChange={this.metabHandleChange.bind(this)}>
                        <option value='0'>Ninguna</option>
                        <option value='1'>Cetoacidosis, coma hiperosmolar</option>
                        <option value='2'>Hipoglicemia severa</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='diabetes-info-containers'>
                  <div className='severity-title'>Severidad</div>
                  <div className='severity-data-labels'>
                    <label className='severity-label'>{this.state.ojosValue}</label>
                    <label className='severity-label'>{this.state.rinonValue}</label>
                    <label className='severity-label'>{this.state.neuroValue}</label>
                    <label className='severity-label'>{this.state.cerebroValue}</label>
                    <label className='severity-label'>{this.state.corazonValue}</label>
                    <label className='severity-label'>{this.state.vascularValue}</label>
                    <label className='severity-label'>{this.state.metabValue}</label>
                  </div>
                </div>
              </div>
              <div className='form-submit-btn-container btn-conditions btn-diabetes'>
                <button id='saveData' className='form-submit-button save-button' onClick={this.saveDiabetes.bind(this)}>Guardar</button>
              </div>
            </div>
          </SkyLight>
        </div>
    )
  }
}

DiabetesData.propTypes = {
  patient: React.PropTypes.string,
  data: React.PropTypes.object,
  inputsRefs: React.PropTypes.object,
  changeStyle: React.PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/Patient/Diabetes.js